module.exports = __webpack_public_path__ + "static/media/productos_otros_pepita_verde.7e12bb80.png";